import { useEffect, useState } from 'react';
import api from './api';

// Small global cache of tag -> color so lesson chips match the colors set in
// the admin Tags tab, without every card refetching.
let _cache = null;
let _loading = null;
const _subs = new Set();

function _notify() { _subs.forEach((fn) => fn()); }

export function loadTagColors() {
  if (_cache) return Promise.resolve(_cache);
  if (!_loading) {
    _loading = api.get('/tags')
      .then(({ data }) => {
        const map = {};
        (data.tags || []).forEach((t) => { if (t.name) map[t.name] = t.color; });
        _cache = map; _notify(); return map;
      })
      .catch(() => { _cache = {}; return {}; });
  }
  return _loading;
}

export function useTagColors() {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    _subs.add(fn);
    loadTagColors();
    return () => { _subs.delete(fn); };
  }, []);
  return _cache || {};
}

// Inline style for a tag chip given its hex color (falls back to null => caller
// uses the default green classes).
export function tagChipStyle(color) {
  if (!color || typeof color !== 'string' || color[0] !== '#') return null;
  return { color, borderColor: `${color}66`, backgroundColor: `${color}1f` };
}
